import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  initialFormData,
  MasterFormDataType,
  MasterTableDataType,
} from "./types";
import usePopup from "../../../hooks/usePopup";
import { useMutation, useQuery } from "react-query";
import { saveMasterData } from "./services";
import { useEffect } from "react";
import {
  Paper,
  Typography,
  Button,
  CircularProgress,
  Divider,
} from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { clinicId } from "../../../constants";
import { getAllCptGrpups } from "../../insuranceMasters/insurancePriceMaster/service";
import useAuthentication from "@hooks/useAuthentication";

const pageTitle = "CPT  ";
function AddOrEditCPT() {
  const navigate = useNavigate();
  const { user } = useAuthentication();

  const { control, handleSubmit, reset } = useForm<MasterFormDataType>({
    defaultValues: initialFormData,
  });
  const { data: cptGroups } = useQuery([], getAllCptGrpups);
  const {
    state: { data = null },
  } = useLocation() as { state: { data: MasterTableDataType } };
  const { showSnackbar } = usePopup();
  const handleGoBack = () => {
    navigate(-1);
  };
  const { mutate: save, isLoading } = useMutation(saveMasterData, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        handleGoBack();
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message:
          e?.response?.data?.responseMessage ||
          e?.response?.data?.errorMessage ||
          "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });
  const onSubmit = (value: MasterFormDataType) => {
    save({
      params: [
        {
          cptClinicId: (data?.cptClinicId as number) || clinicId,
          cptCode: value?.cptCode,
          cptCreatedById: Number(user?.userId),
          cptDes: value?.description,
          cptGroupId: value?.cptGroupName?.cptGroupId as number,
          cptId: data?.cptId || null,
          cptName: value?.cptName,
          cptPoId: (data?.cptPoId as number) || 0,
          cptRate: Number(value?.rate),
          cptStatus: value?.status,
          cptType: data?.cptType || null,
          isPackage: value.isPackage,
          lonicCode: (data?.lonicCode as string) || "",
          lonicValue: (data?.lonicValue as number) || 0,
          lonicUnit: (data?.lonicUnit as string) || "",
          needLonicCode: value.needLonicCode,
          specimenId: (data?.specimenId as number) || 0,
        },
      ],
      codetype: String(user?.codetype),
    });
  };

  const handleReset = () => {
    reset(initialFormData);
  };

  useEffect(() => {
    console.log("data", data?.cptStatus);

    if (data) {
      reset({
        cptCode: data.cptCode,
        cptName: data?.cptName,
        cptGroupName: {
          cptGroupId: data?.cptGroupId,
          cptGroupName: data?.cptGroupName,
        },
        description: data?.cptDes,
        rate: data?.cptRate,
        status: data?.cptStatus ? 1 : 0,
        isPackage: data?.isPackage,
        needLonicCode: data?.needLonicCode,
      });
    }
  }, [data]);

  return (
    <div className="p-3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                {data ? "Update" : "Add"} {pageTitle}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                disabled={isLoading}
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
              >
                back
              </Button>
              {!Boolean(data) && (
                <Button
                  disabled={isLoading}
                  color="error"
                  type="reset"
                  onClick={handleReset}
                  startIcon={<CloseIcon />}
                >
                  reset
                </Button>
              )}
              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <SaveIcon />
                  )
                }
              >
                {data ? "update" : "save"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-3">
            <CustomFormField
              control={control}
              name="cptCode"
              element="input"
              fieldProps={{ label: "Enter Cpt code " }}
              rules={{ required: "Code is required" }}
            />
            <CustomFormField
              control={control}
              name="cptName"
              element="input"
              fieldProps={{ label: "Enter Cpt name " }}
              rules={{ required: "Name is required" }}
            />
            <CustomFormField
              control={control}
              name="cptGroupName"
              element="autocomplete"
              options={cptGroups?.response || []}
              autocompleteProps={{
                getOptionLabel: (option) => option.cptGroupName,
                isOptionEqualToValue: (option, value) =>
                  option.cptGroupId == value.cptGroupId,
              }}
              fieldProps={{ label: "Enter cpt group name" }}
              rules={{ required: "cpt group required" }}
            />

            <CustomFormField
              control={control}
              name="rate"
              element="input"
              fieldProps={{ label: "Enter Rate " }}
              rules={{ required: "rate  is required" }}
            />
            <CustomFormField
              control={control}
              name="description"
              element="input"
              fieldProps={{ label: "Enter Description " }}
              rules={{ required: "Description  is required" }}
            />
            <CustomFormField
              control={control}
              name="isPackage"
              element="checkbox"
              fieldProps={{
                label: "Is Package ",
              }}
              rules={{ required: false }}
            />
            <CustomFormField
              control={control}
              name="needLonicCode"
              element="checkbox"
              fieldProps={{ label: "Need LonicCode " }}
              rules={{ required: false }}
            />

            <CustomFormField
              control={control}
              name="status"
              element="radio"
              radioProps={{ row: true }}
              radios={[
                { label: "Active", value: 1 },
                { label: "Inactive", value: 0 },
              ]}
              fieldProps={{ label: "Status " }}
              rules={{ required: "Status is required" }}
            />
          </div>
        </Paper>
      </form>
    </div>
  );
}

export default AddOrEditCPT;
